module.exports = __webpack_public_path__ + "images/118_640.jpg";